import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { MenuBaseComponent } from './components/menu-base/menu-base.component';
import { MenuPageComponent } from './components/menu-page/menu-page.component';
import { MenuSectionComponent } from './components/menu-section/menu-section.component';
import { CartComponent } from './components/cart/cart/cart.component';
import { ReceiptListComponent } from './components/receipt-list/receipt-list.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { PayStatusComponent } from './components/pay-status/pay-status.component';
import { ModernFeedComponent } from './components/feed/modern-feed.component';
import { StartPageComponent } from './components/start-page/start-page.component';
import { LivesplitComponent } from './components/livesplit/livesplit.component';
import { TermsComponent } from './components/terms/terms.component';
import { SettlementComponent } from './components/settlement/settlement.component';
import { GdprComponent } from './components/gdpr/gdpr.component';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { ConnectMessengerComponent } from './components/my-account/connect-messenger/connect-messenger.component';
import { SignOutComponent } from './components/sign-out/sign-out.component';
import { SelectLangComponent } from './components/select-lang/select-lang.component';
import {ButtonPreviewComponent} from './components/buttons/button-preview.component';
import {GiftcardComponent} from './components/giftcard/giftcard.component';
import { MenuOfTheWeekComponent } from './components/menu-of-the-week/menu-of-the-week.component';
import { PaymentFailedComponent } from './components/payment-failed/payment-failed.component';
import {VoucherComponent} from './components/glance-voucher/new-glance-voucher';
import { LoyaltyCardHistoryComponent } from './components/ui/loyalty-card-history.component';
import { SelectVoucherComponent } from './components/select-voucher/select-voucher.component';
import { ReviewComponent } from './components/review/review.component';
import { KioskEntryComponent } from './components/kiosk-entry/kiosk-entry.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { BookingViewComponent } from './components/booking-view/booking-view.component';
import { PrebookEntryComponent } from './components/prebook-entry/prebook-entry.component';
import { PrebookJoinComponent } from './components/prebook-join/prebook-join.component';
import { WaitlistQueueComponent } from './components/waitlist/waitlist-queue.component';
import { WaitlistStatusComponent } from './components/waitlist/waitlist-status.component';
import { ReservationManageComponent } from './components/reservation/reservation-manage.component';
import {keepTableInUrl} from './services/table-code.service';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'kiosk/:venue_id/:table_code', component: KioskEntryComponent },
  { path: 'delete', component: DeleteAccountComponent },

  {
    path: ":venue_id", component: MenuBaseComponent, canActivate: [], canActivateChild: [keepTableInUrl],
    children: [
      { path: "", redirectTo: 'menu/food', pathMatch: 'full' },
      { path: "start", component: StartPageComponent, canActivate: [] },
      { path: "menu/:page_id", component: MenuPageComponent, canActivate: [] },
      { path: "menu/:page_id/:section_id", component: MenuSectionComponent, canActivate: [] },
      { path: "cart", component: CartComponent, canActivate: [] },
      { path: "cart/paymentfailed", component: PaymentFailedComponent, data: { origin: "cart" }, canActivate: [] },
      { path: "receipts", component: ReceiptListComponent, canActivate: [] },
      { path: "receipt/:receipt_id", component: ReceiptComponent, canActivate: [] },
      { path: "feed", component: ModernFeedComponent, canActivate: [] },
      { path: "paystatus/:receipt_key", component: PayStatusComponent, canActivate: [] },
      { path: "livesplit", component: LivesplitComponent, canActivate: [] },
      { path: "livesplit/paymentfailed", component: PaymentFailedComponent, data: { origin: "livesplit" }, canActivate: [] },
      { path: "livesplit/:receipt_key", component: LivesplitComponent, canActivate: [] },
      { path: "vouchers", component: SelectVoucherComponent, canActivate: [] },
      { path: "pl/:pl_key", component: LivesplitComponent, canActivate: [] },
      { path: "glance/:voucher_id", component: VoucherComponent, canActivate: [] },
      { path: "terms", component: TermsComponent, canActivate: [] },
      { path: "settlement", component: SettlementComponent, canActivate: [] },
      { path: "settlement/:receipt_key", component: SettlementComponent, canActivate: [] },
      { path: "gdpr", component: GdprComponent, canActivate: [] },
      { path: "account", component: MyAccountComponent, canActivate: [] },
      { path: "connect-messenger", component: ConnectMessengerComponent, canActivate: [] },
      { path: "signout", component: SignOutComponent, canActivate: [] },
      { path: "button-preview", component: ButtonPreviewComponent, canActivate: [] },
      { path: "select-lang", component: SelectLangComponent, canActivate: [] },
      { path: "giftcard/:post_id", component: GiftcardComponent, canActivate: [] },
      { path: "g/:post_id", component: GiftcardComponent, data: { receiver_layout: true }, canActivate: [] },
      { path: "week", component: MenuOfTheWeekComponent, canActivate: [] },
      { path: "loyalty-history/:card_key", component: LoyaltyCardHistoryComponent, canActivate: [] },
      { path: "review", component: ReviewComponent, canActivate: [] },
      { path: "b", component: PrebookEntryComponent, canActivate: [] },
      { path: "bj/:token", component: PrebookJoinComponent, canActivate: [] },
      { path: "booking/:booking_id", component: BookingViewComponent, canActivate: [] },
      { path: "queue", component: WaitlistQueueComponent, canActivate: [] },
      { path: "waitlist/:ref", component: WaitlistStatusComponent, canActivate: [] },
      { path: "reservation/:ref", component: ReservationManageComponent, canActivate: [] },
    ]
  },

];
